// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { RateTokens } from './type';

const rateTokens: RateTokens = {
  rateFontColor: 'Neutral-text-5',
  rateFontSize: '14/regular',
  rateGap: 'Size-3',
  rateSize: 'Size-12',
  rateBackgroundColor: 'Neutral-fill-3',
  rateFrontBackgroundColor: 'Warning-5',
};

export default rateTokens;
